import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const apiUrl = process.env.REACT_APP_API_URL;

function AdminLogin() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // Check for existing session on component mount
  useEffect(() => {
    const sessionData = JSON.parse(sessionStorage.getItem('adminSession'));
    if (sessionData && sessionData.token) {
      // Verify token with the server
      axios.get(`${apiUrl}/api/admin/dashboard`, {
        headers: { Authorization: `Bearer ${sessionData.token}` }
      })
        .then(() => {
          navigate('/admin-dashboard');
        })
        .catch(() => {
          sessionStorage.removeItem('adminSession');
        });
    }
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await axios.post(`${apiUrl}/api/admin/login`, {
        username,
        password
      });

      if (response.data.success) {
        // Store session data
        const sessionData = {
          token: response.data.token,
          id: response.data.id,
          username: response.data.username,
          email: response.data.email,
          name: response.data.name // Assuming name is returned from the server
        };
        sessionStorage.setItem('adminSession', JSON.stringify(sessionData));
        
        // Redirect to dashboard
        navigate('/admin-dashboard');
      } else {
        setError(response.data.message || 'Login failed');
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Server error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/*==================== Sidebar Overlay End ====================*/}
      <div className="side-overlay" />
      {/*==================== Sidebar Overlay End ====================*/}
      <section className="auth d-flex">
        <div className="auth-left bg-main-50 flex-center p-24 bg-image-cover">
          {/* Image removed, handled by CSS background */}
        </div>
        <div className="auth-right py-40 px-24 flex-center flex-column">
          <div className="auth-right__inner mx-auto w-100">
            <a href="index.html" className="auth-right__logo">
              <img src="/assets/images/logo/logo.jpg" alt="" />
            </a>
            <h2 className="mb-8">Welcome to IFM Edu LMS!</h2>
            <p className="text-gray-600 text-15 mb-32">
              Please sign in to your account and start learning.
            </p>
            {error && (
              <div className="alert alert-danger" role="alert">
                {error}
              </div>
            )}
            <form onSubmit={handleSubmit}>
              <div className="mb-24">
                <label htmlFor="fname" className="form-label mb-8 h6">
                  Email or Username
                </label>
                <div className="position-relative">
                  <input
                    type="text"
                    className="form-control py-11 ps-40"
                    id="fname"
                    placeholder="Type your username"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    disabled={loading}
                  />
                  <span className="position-absolute top-50 translate-middle-y ms-16 text-gray-600 d-flex">
                    <i className="ph ph-user" />
                  </span>
                </div>
              </div>
              <div className="mb-24">
                <label htmlFor="current-password" className="form-label mb-8 h6">
                  Current Password
                </label>
                <div className="position-relative">
                  <input
                    type="password"
                    className="form-control py-11 ps-40"
                    id="current-password"
                    placeholder="Enter Current Password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    disabled={loading}
                  />
                  <span
                    className="toggle-password position-absolute top-50 inset-inline-end-0 me-16 translate-middle-y ph ph-eye-slash"
                    id="#current-password"
                  />
                  <span className="position-absolute top-50 translate-middle-y ms-16 text-gray-600 d-flex">
                    <i className="ph ph-lock" />
                  </span>
                </div>
              </div>
              <div className="mb-32 flex-between flex-wrap gap-8">
                <div className="form-check mb-0 flex-shrink-0">
                  <input
                    className="form-check-input flex-shrink-0 rounded-4"
                    type="checkbox"
                    id="remember"
                    disabled={loading}
                  />
                  <label
                    className="form-check-label text-15 flex-grow-1"
                    htmlFor="remember"
                  >
                    Remember Me
                  </label>
                </div>
              </div>
              <button
                type="submit"
                className="btn btn-main rounded-pill w-100"
                disabled={loading}
              >
                {loading ? 'Signing In...' : 'Sign In'}
              </button>
            </form>
          </div>
        </div>
      </section>
    </>
  );
}

export default AdminLogin;